module.exports = __webpack_public_path__ + "static/media/weiterRot.ded86afe.svg";